"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionsListTile = void 0;
const moment_1 = __importDefault(require("moment"));
const React = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const rightVector_svg_1 = __importDefault(require("../../../../assets/icons/rightVector.svg"));
const colors_1 = require("../../../../assets/styles/colors");
const hooks_1 = require("../../../../store/hooks");
const sessionFiltersSlice_1 = require("../../../../store/sessionFiltersSlice");
const thresholdSlice_1 = require("../../../../store/thresholdSlice");
const dateFormat_1 = require("../../../../types/dateFormat");
const thresholdColors_1 = require("../../../../utils/thresholdColors");
const S = __importStar(require("./SessionListTile.style"));
const AverageValueDisplay = ({ averageValue }) => {
    if (typeof averageValue === "number") {
        return React.createElement(S.Subtitle, null,
            "avg. ",
            averageValue);
    }
    const { t } = (0, react_i18next_1.useTranslation)();
    return React.createElement(S.Subtitle, null,
        "avg. ",
        t("map.calculating"));
};
const SessionsListTile = ({ id, sessionName, sensorName, averageValue, startTime, endTime, streamId, onClick, onMouseEnter, onMouseLeave, isIndoor, isDormant, }) => {
    const thresholds = (0, react_redux_1.useSelector)(thresholdSlice_1.selectThresholds);
    const { t } = (0, react_i18next_1.useTranslation)();
    const [formattedStartDate, formattedStartTime] = (0, moment_1.default)(startTime, dateFormat_1.DateFormat.default_with_time)
        .format(dateFormat_1.DateFormat.us_with_time)
        .split(" ");
    const [formattedEndDate, formattedEndTime] = (0, moment_1.default)(endTime, dateFormat_1.DateFormat.default_with_time)
        .format(dateFormat_1.DateFormat.us_with_time)
        .split(" ");
    const handleClick = () => {
        if (onClick) {
            onClick(id, streamId);
        }
    };
    const handleMouseHover = () => {
        if (onMouseEnter) {
            onMouseEnter(id);
        }
    };
    const handleMouseLeave = () => {
        if (onMouseLeave) {
            onMouseLeave();
        }
    };
    const isDormantSession = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectIsDormantSessionsType);
    const dotColor = isDormantSession
        ? colors_1.gray300
        : (0, thresholdColors_1.getColorForValue)(thresholds, averageValue);
    const shouldShowValue = !(isIndoor || (isDormant && averageValue === null));
    return (React.createElement(S.SessionListTile, { "$isIndoor": isIndoor, onClick: handleClick, onMouseOver: handleMouseHover, onMouseLeave: handleMouseLeave },
        React.createElement(S.HorizontalSpacingContainer, { "$isIndoor": isIndoor },
            React.createElement(S.HorizontalGroup, null,
                shouldShowValue && (React.createElement(S.ColorDot, { "$color": dotColor, "$isAvg": typeof averageValue === "number" })),
                shouldShowValue && (React.createElement(AverageValueDisplay, { averageValue: averageValue }))),
            React.createElement(S.ArrowImageContainer, null,
                React.createElement("img", { src: rightVector_svg_1.default, alt: t("map.altDirect") }))),
        React.createElement(S.Title, { "$isIndoor": isIndoor }, sessionName),
        React.createElement(S.Subtitle, { "$isIndoor": isIndoor }, sensorName),
        React.createElement(S.Subtitle, { "$isIndoor": isIndoor },
            React.createElement("strong", null, formattedStartDate),
            " ",
            formattedStartTime,
            " -",
            " ",
            React.createElement("strong", null, formattedEndDate),
            " ",
            formattedEndTime)));
};
exports.SessionsListTile = SessionsListTile;
